import React, { SetStateAction } from 'react';
import { useFilteredData } from './useFilteredData';
import { shallowEqual, useSelector } from 'react-redux';
import styles from './index.module.scss';

interface FilterCardProps {
  entry: {
    logo: string;
    image: string;
    merchant_logo: string;
    id: string | number;
    merchant_id: string | number;
    issuer_id: string | number;
    primary_category_id: string;
    name: string;
    data: string;
    merchant_name: string;
    issuer_name: string;
  };
  activeFilter: string;
  handleSelect: SetStateAction<object>;
}

const FilterCard = ({ entry, activeFilter, handleSelect }: FilterCardProps) => {
  const { filterOnIssuer, filterOnSubCategory } = useFilteredData();
  const tempAppliedFilters = useSelector(
    ({ appReducer }) => appReducer.tempAppliedFilters,
    shallowEqual,
  );
  const imageUrl = entry.logo || entry.image || entry.merchant_logo;
  const eleId = entry.id || entry.merchant_id || entry.issuer_id;
  let disabled = false;
  if (activeFilter === 'brand' && tempAppliedFilters.category?.length) {
    disabled =
      !tempAppliedFilters.category?.includes(entry.primary_category_id) &&
      Number(entry.primary_category_id) !== 1;
  } else if (activeFilter === 'offer_type') {
    disabled = !filterOnSubCategory.some((ele: { offer_tag: string }) => {
      return entry.id === ele.offer_tag;
    });
  } else if (activeFilter === 'offer_value') {
    disabled = !filterOnIssuer.some((ele: { offer_value: string }) => {
      return Number(entry.id) <= Number(ele.offer_value);
    });
  }

  if (activeFilter === 'platform' && entry.id !== 'all') {
    return null;
  }

  const checked =
    tempAppliedFilters[activeFilter]?.includes(eleId) && !disabled;

  return (
    <div
      className={styles.filterCard}
      onClick={() => !disabled && handleSelect(eleId)}
      style={{
        opacity: disabled ? 0.3 : 1,
      }}
    >
      <div className={styles.filterName}>
        {imageUrl ? (
          <img
            loading="lazy"
            src={imageUrl}
            style={{
              maxWidth: activeFilter === 'offer_type' ? '32px' : '48px',
              minHeight: activeFilter === 'offer_type' ? '32px' : '48px',
            }}
            alt={
              entry.name ||
              entry.data ||
              entry.merchant_name ||
              entry.issuer_name
            }
          />
        ) : null}
        <div className={styles.name}>
          {entry.name || entry.data || entry.merchant_name || entry.issuer_name}
        </div>
      </div>
      <div className={styles.radio}>
        <input
          type="checkbox"
          checked={checked ?? false}
          onChange={() => handleSelect(eleId)}
        />
      </div>
    </div>
  );
};

export default React.memo(FilterCard);
